import axios from "@/api/axiosInstance";
import { OpportunitiesResponse } from "../types";

export const fetchOpportunitiesByProspect = async (
  email: string,
  signal?: AbortSignal,
): Promise<OpportunitiesResponse> => {
  const response = await axios.get<OpportunitiesResponse>(
    `/api/private/sales-portal/opportunities/prospect/${encodeURIComponent(email)}`,
    { signal },
  );
  return response.data;
};
